import moment from "moment";
import { z } from "zod";

export const centerHoursDaySchema = z
  .object({
    id: z.number().optional(),
    weekday: z.number(),
    isClosed: z.boolean().default(false),
    openTime: z.string(),
    closeTime: z.string(),
    startApptTime: z.string(),
    endApptTime: z.string(),
    seasonStart: z.string(),
    seasonEnd: z.string()
  })
  .refine(val => !(!val.isClosed && !val.openTime), {
    message: "error",
    path: ["openTime"]
  })
  .refine(val => !(!val.isClosed && !val.closeTime), {
    message: "error",
    path: ["closeTime"]
  })
  .refine(
    val =>
      val.isClosed ||
      !val.openTime ||
      !val.closeTime ||
      moment(val.openTime, "HH:mm:ss").isBefore(moment(val.closeTime, "HH:mm:ss")),
    {
      message: "Close time must be after open time",
      path: ["closeTime"]
    }
  );

export type CenterHoursDaySchema = z.infer<typeof centerHoursDaySchema>;
